import { useEffect, useState } from 'react';

/**
 * SVG readiness ring. Two spec sizes:
 *   small — 72px, r=30, stroke 7 (score rail; 600ms transitions)
 *   big   — 150px, r=64, stroke 11 (results hero; 1200ms animate-in)
 */
export default function ScoreRing({ score, color, size = 'small', children }) {
  const big = size === 'big';
  const dim = big ? 150 : 72;
  const r = big ? 64 : 30;
  const stroke = big ? 11 : 7;
  const circumference = big ? 402.1 : 188.5;

  // Big ring animates in from 0 on mount (results reveal).
  const [displayScore, setDisplayScore] = useState(big ? 0 : score);
  useEffect(() => {
    if (!big) {
      setDisplayScore(score);
      return undefined;
    }
    const raf = requestAnimationFrame(() => requestAnimationFrame(() => setDisplayScore(score)));
    return () => cancelAnimationFrame(raf);
  }, [big, score]);

  const offset = circumference * (1 - displayScore / 100);
  const transition = big
    ? 'stroke-dashoffset 1200ms cubic-bezier(0.4,0,0.2,1)'
    : 'stroke-dashoffset 600ms cubic-bezier(0.4,0,0.2,1), stroke 600ms';

  return (
    <div className="rdz-ring" style={{ width: dim, height: dim }}>
      <svg width={dim} height={dim} viewBox={`0 0 ${dim} ${dim}`}>
        <circle cx={dim / 2} cy={dim / 2} r={r} fill="none" stroke="#eceae5" strokeWidth={stroke} />
        <circle
          cx={dim / 2}
          cy={dim / 2}
          r={r}
          fill="none"
          stroke={color}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${dim / 2} ${dim / 2})`}
          style={{ transition }}
        />
      </svg>
      {children}
    </div>
  );
}
